import { Card, CardContent, CardHeader, CardTitle } from "../ui/card";
import { cn } from "../../lib/utils";

export function ConnectionsPage({ children, className, maxWidth, testId }) {
  const isPxValue = typeof maxWidth === "string" && /^\d+px$/.test(maxWidth);
  const twClass = !maxWidth ? "max-w-7xl" : isPxValue ? "" : maxWidth;
  return (
    <div
      className={cn("connections-page mx-auto w-full px-6 py-6 pb-24", twClass, className)}
      style={isPxValue ? { maxWidth } : undefined}
      data-testid={testId}
    >
      {children}
    </div>
  );
}

export function ConnectionsHeader({ title, subtitle, actions, className }) {
  return (
    <div className={cn("connections-header flex flex-col gap-4 sm:flex-row sm:items-center sm:justify-between border-b pb-6 mb-6", className)}>
      <div className="min-w-0">
        <h2 className="text-2xl font-bold tracking-tight">{title}</h2>
        {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
      </div>
      {actions && <div className="flex shrink-0 flex-wrap items-center gap-3">{actions}</div>}
    </div>
  );
}

export function ConnectionsCard({ title, subtitle, actions, children, className, contentClassName }) {
  return (
    <Card className={cn("border-border/50 shadow-sm", className)}>
      {(title || subtitle || actions) && (
        <CardHeader className="border-b border-border/40 bg-muted/20 pb-4">
          <div className="flex items-start justify-between gap-3">
            <div>
              {title && <CardTitle className="text-base font-semibold">{title}</CardTitle>}
              {subtitle && <p className="text-sm text-muted-foreground mt-0.5">{subtitle}</p>}
            </div>
            {actions && <div className="flex shrink-0 items-center gap-2">{actions}</div>}
          </div>
        </CardHeader>
      )}
      <CardContent className={cn("p-4", contentClassName)}>
        {children}
      </CardContent>
    </Card>
  );
}

export function ConnectionsStatCard({ value, label, icon: Icon, tone = "neutral" }) {
  return (
    <Card className={cn("border-border/50", tone === "red" && "border-red-200 dark:border-red-800", tone === "dark" && "border-foreground/20")}>
      <CardContent className="flex h-full items-center justify-between p-4">
        <div>
          <p className="text-2xl font-bold tracking-tight">{value}</p>
          <p className="text-xs text-muted-foreground mt-0.5">{label}</p>
        </div>
        {Icon && (
          <div className="p-2 rounded-lg bg-primary/10">
            <Icon className="h-5 w-5 text-primary" />
          </div>
        )}
      </CardContent>
    </Card>
  );
}
